import { color } from '@starryui10/theme/color';
import React, { FC } from 'react';
import styled from 'styled-components';

interface IHoverOverContainerProps {
    width?: string;
}

export const HoverOverContainer: FC<IHoverOverContainerProps> = ({ children, width }) => {
    return <Dropdown width={width}>{children}</Dropdown>;
};

const Dropdown = styled.div<IHoverOverContainerProps>`
    color: ${color.Grey.G80};
    background: white;
    padding: 0;
    margin: 0;
    width: ${(props) => props.width};
    border: 1px solid ${color.Grey.G30};
    box-shadow: 0px 2px 30px ${color.Grey.G30};
    border-radius: 4px;
    z-index: 10;
`;
